import React from "react";

import Homebanner from "./Homebanner";

import Addsection from "./Addsection";

import Featureproduct from "./Featureproduct";

import Category from "./Category";

import Ourproduct from "./Ourproduct";

import { useLocation } from "react-router-dom";

import { Helmet } from "react-helmet";

import axios from "axios";

import { api } from "../Constants";

import { useState, useEffect } from "react";

import Header from "../Header/Header";

import Footer from "../Footer/Footer";

import Image1 from "../../assets/new-images/svg_logo.svg";

function Homeparent() {

  const routePath = useLocation();



  const onTop = () => {

    window.scrollTo(0, 0);

  };



  useEffect(() => {

    onTop();

  }, [routePath]);



  const [loading, setLoding] = useState(true);



  const userid = localStorage.getItem("userid");



  const [data, setData] = useState([]);

  useEffect(() => {

    const apiUrl = api + "banner_list";

    axios

      .post(apiUrl)

      .then((response) => {

        setData(response.data.data);

        setLoding(false);

        if (response.data.data !== undefined && response.data.data.length > 0) {

        }

      })

      .catch((error) => {

        if (error.response) {

          console.log("Server Error:", error.response.data);

        } else if (error.request) {

          console.log("No Response Received");

        } else {

          console.log("Error:", error.message);

        }

      });

  }, []);



  const [datas, setDatas] = useState([]);



  useEffect(() => {

    const apiUrl = api + "ads_list";

    axios

      .post(apiUrl)

      .then((response) => {

        setDatas(response.data.data);

        setLoding(false);

      })

      .catch((error) => {

        if (error.response) {

          console.log("Server Error:", error.response.data);

        } else if (error.request) {

          console.log("No Response Received");

        } else {

          console.log("Error:", error.message);

        }

      });

  }, []);



  const [datasss, setDatasss] = useState([]);



  useEffect(() => {

    const apiUrl = api + "select_featuredproduct";



    axios

      .post(apiUrl, {

        dealer_id: userid,

      })

      .then((response) => {

        setDatasss(response.data.data);

        setLoding(false);

        

      })

      .catch((error) => {

        if (error.response) {

          console.log("Server Error:", error.response.data);

        } else if (error.request) {

          console.log("No Response Received");

        } else {

          console.log("Error:", error.message);

        }

      });

  }, []);



  const [categorylist, setCategorylist] = useState([]);



  useEffect(() => {

    axios

      .post(api + "category_list", {

        dealer_id: userid,

      })

      .then((response) => {

        setCategorylist(response.data.data);

        setLoding(false);

      })

      .catch((error) => {

        console.log("Error:", error);

      });

  }, []);



  return (

    <>

      <>

        <Helmet>Home</Helmet>

      </>

     {loading ? (
  <section style={{ height: "100vh", backgroundColor: "#fff" }}>
    <div className="container h-100">
      <div className="row h-100">
        <div className="col-12 d-flex flex-column justify-content-center align-items-center">
          {/* Logo */}
          <img
            src={Image1}
            alt="Loading Logo"
            style={{
              width: "320px",
              height: "auto",
              animation: "pulse 1.5s infinite ease-in-out",
              marginBottom: "30px",
            }}
          />

          {/* Spinner */}
          <div className="dot-spinner">
            {Array(8)
              .fill(0)
              .map((_, idx) => (
                <div className="dot-spinner__dot" key={idx}></div>
              ))}
          </div>
        </div>
      </div>
    </div>
  </section>
)  : (

        <>

          <Header />

          <Homebanner data={data} />

          <Addsection datas={datas} />

          <Featureproduct datasss={datasss} />

          <Category categorylist={categorylist} />

          <Ourproduct />

          <Footer />

        </>

      )}

    </>

  );

}



export default Homeparent;

